// extracted by mini-css-extract-plugin
export var header = "_hg-0";